import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_ACCOUNT_LINKED_IMY_STRUCTURE_REQUEST = 'GET_ACCOUNT_LINKED_IMY_STRUCTURE_REQUEST';
export const GET_ACCOUNT_LINKED_IMY_STRUCTURE_SUCCESS = 'GET_ACCOUNT_LINKED_IMY_STRUCTURE_SUCCESS';
export const GET_ACCOUNT_LINKED_IMY_STRUCTURE_FAILURE = 'GET_ACCOUNT_LINKED_IMY_STRUCTURE_FAILURE';
export const GET_ACCOUNT_LINKED_IMY_STRUCTURE_CLEAR = 'GET_ACCOUNT_LINKED_IMY_STRUCTURE_CLEAR';

function request() {
  return {
    type: GET_ACCOUNT_LINKED_IMY_STRUCTURE_REQUEST,
  };
}

function receive(linkedImyStructure) {
  return {
    type: GET_ACCOUNT_LINKED_IMY_STRUCTURE_SUCCESS,
    linkedImyStructure
  };
}

function reject() {
  return {
    type: GET_ACCOUNT_LINKED_IMY_STRUCTURE_FAILURE,
  };
}

function clear() {
  return {
    type: GET_ACCOUNT_LINKED_IMY_STRUCTURE_CLEAR,
  };
}

export function clearAccountLinkedImyStructure() {
  return (dispatch) => {
    dispatch(clear());
  };
}

export function getAccountLinkedImyStructure(id) {
  return (dispatch) => {
    dispatch(request());
    const promise = () => ApiService
      .getAccountLinkedImyStructure(id)
      .then((response) => {
        if (response.data) {
          dispatch(receive(response.data));
        }
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });

    return promise();
  };
}
